import React, { Component } from 'react';

class PrivacyPolicy extends Component {
    constructor(props) {
        super(props);
        localStorage.setItem('catData',"");
    }
    render() {
        return (
            <section class="ovrfl">
                <div class="container">

                    <div class="row breadcrumb text-center trght">
                        <div class="col-md-12">
                            <span>Home</span> <i class="fa fa-angle-right"></i>
                            <span>Pages</span> <i class="fa fa-angle-right"></i>
                            <span>PRIVACY POLICY </span>
                        </div>
                    </div>

                    <div class="row pad_0">
                        <div class="col-md-12 term_bg">

                            <h1 class="term-h">PRIVACY POLICY</h1>

                            <p class="term-p">We respect the privacy of everyone who visits this website. As a result we would like to inform you regarding the way we would use your personal data. We recommend you to read this privacy policy so that you understand our approach towards the use of your personal data</p>

                            <p class="term-p">By submitting your personal data to us, you will be treated as having given your permission's where necessary and appropriate for disclosures referred to in this policy.</p>



                            <h2 class="term-h2">What does this privacy policy cover?</h2>


                            <p class="term-p">This privacy policy is to inform you regarding the use of your personal information that is collected during your visit to our website.

                            </p>


                            <h2 class="term-h2">What information do we collect?</h2>


                            <ul class="term-ul">
                                <li>Details of your visits to our website and the resources that you access, including, but not limited to, traffic data, location data, weblogs, IP address, operating system, access times, what browser you are using and other communication data.</li>
                                <li>Information that you provide by filling in forms on our website, such as when you register for information or make a purchase.</li>
                                <li>Information provided to us when you communicate with us for any reason.</li>
                            </ul>



                            <h2 class="term-h2"> Purposes of collecting your data</h2>

                            <p class="term-p">One of the purposes of our website is to inform you of who we are and what we do. We collect and use personal information (including name, address, telephone number and email) to better provide you with the required services, or information. We would therefore use your personal information in order to:</p>

                            <ul class="term-ul">
                                <li>To provide you with information requested from us, relating to our products or services. To provide information on other products or services within our group of companies, subsidiaries, related companies and affiliates, which we feel may be of interest to you.</li>
                                <li>To meet our contractual commitments to you.</li>
                                <li>To notify you about any changes to our website, such as improvements or service/product changes, that may affect our service.</li>
                                <li>Personalize your experience.</li>
                            </ul>

                            <p class="term-p">Furthermore, we may use your data, or permit selected third parties to use your data, so that you can be provided with information about unrelated products and services that we consider may be of interest to you. You may stop these messages at any time by opting-out using the opt-out tool at the bottom of the email communication. Please be assured that we will not use your information for any of the purposes if you have indicated that you do not wish us to use your information in this way when submitting the information or at a later stage.</p>


                            <h2 class="term-h2">Changes to this policy</h2>


                            <p class="term-p">From time to time we may make changes to this privacy policy. If we make any substantial changes to this privacy policy and the way in which we use your personal data we will post these changes on this page and will do our best to notify you of any significant changes. Please check our privacy policy on a regular basis.</p>



                        </div>
                    </div>

                </div>
            </section>

        );
    }


}


export default PrivacyPolicy;


// WEBPACK FOOTER //
// ./src/Misc/PrivacyPolicy/PrivacyPolicy.js